export const isValidUrl = (url: string) => {
    if (!url) return false;
    try {
        new URL(url);
        return true;
    } catch {
        return false;
    }
};

export const isPaymentScheduleValid = (items: any[]): boolean => {
    if (!Array.isArray(items) || items.length === 0) return false;

    return items.every(
        (item) =>
            item &&
            typeof item.key === 'string' &&
            item.key.trim() !== '' &&
            typeof item.value === 'string' &&
            item.value.trim() !== '',
    );
};

export const areFieldsEmpty = (obj: { [key: string]: any }): boolean => {
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const value = obj[key];
            if (value === null || value === undefined || value === '') {
                return true;
            }
        }
    }
    return false;
};

export const isEmptyHtml = (html: string | undefined | null): boolean => {
    if (!html) return true;

    const cleaned = html.trim();

    if (cleaned === '') return true;

    const emptyTagRegex =
        /^(\s*<(p|div|span|br)[^>]*>\s*(<br\s*\/?>)?\s*<\/\2>\s*)+$/i;

    const singleBrRegex = /^<br\s*\/?>$/i;

    return emptyTagRegex.test(cleaned) || singleBrRegex.test(cleaned);
};
